export const state = {
  debug: false,
  configJSON: null,
  websocket: null,

  currentSessionType: -1,
  currentSlalomMode: -1,
  displayClasses: false,
  displayRaceTime: false,
  noSectors: 0,
  currentClasses: [],
  newClass: "ALL",
  // tab identifire requested via the "?class=" URL param on load (e.g. "G0V1",
  // not just "G0" - so V1/V2/Grid sub-tabs are restored precisely); consumed
  // once by the first createRankingDiv() call after load.
  pendingUrlTab: null,
  // "?scroll" URL param present on load - shows the Scroll (run history) tab
  // even when config.json's "showScroll" is off.
  scrollRequested: false,
  // "?grid" URL param present on load - shows the Grid (by start number) tab
  // even when config.json's "showGrid" is off.
  gridRequested: false,
  selectNewClass: false,
  displayGroup: false,
  displayGuest: false,
  displayMake: false,

  // values pushed by the server per session telegram, take precedence over configJSON in getSetting()
  serverSettings: {},

  currentSite: null,
  currentButton: null,
  tableIdentifires: [],
};
